import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function CheckIcon({ width = 24, height = 24, color = 'black' }) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <Path
        d="M21 7L9 19l-5.5-5.5 1.41-1.41L9 16.17 19.59 5.59 21 7z"
        fill={color}
      />
    </Svg>
  );
}

export default CheckIcon;
